const PriceColorBlack = '#161616';
const PriceColorGray = '#737373';

const PriceFontSmall = '0.875rem';
const PriceFontDefault = '1rem';

export { PriceColorBlack, PriceColorGray, PriceFontSmall, PriceFontDefault };
